import WidgetService from "../../../../core/services/widgetService.js";

export default class ChartUtil {
  static setTimestampLabelSpacing($chart) {
    let width = $chart.epoch({type: 'line'}).option("width");
    let historySize = $chart.epoch({type: 'line'}).option("historySize");
    let spacePerPoint = width / historySize;
    // 200px is the hardcoded width of the timestamp label
    let numPointsPerTimestamp = Math.floor((200 / spacePerPoint) + 1);
    if (numPointsPerTimestamp < 3) numPointsPerTimestamp = 3;
    $chart.epoch({type: 'line'}).option("ticks", {
      time: numPointsPerTimestamp,
      left: 5, right: 5
    });
  }

  static resizeCharts(widgetId, newHeight, newWidth, isVertical) {
    // console.log("resize chart " + newHeight + "," + newWidth);
    const widgetModel = WidgetService.getWidget(widgetId);
    let widget = $("#" + widgetId);
    let titleHeight = widget.find(".widget-header").outerHeight(true),
      legendHeight = widget.find("div[name=legendContainer]").outerHeight(true),
      legendWidth = widget.find("div[name=legendContainer]").outerWidth(true);
    let mainChart = widget.find("div.epoch")[0];

    let legendLines = Math.ceil(legendWidth / newWidth);
    legendHeight *= legendLines;

    if (titleHeight === null) titleHeight = 50;
    if (widget.parents("#code-chart-container").length > 0) titleHeight = 0;

    titleHeight = widgetModel.title.trim().length > 0 ? 28 : 0;

    if (isVertical) {
      $(mainChart).epoch({type: 'line'}).option("height", newWidth);
      $(mainChart).epoch({type: 'line'}).option("width", newHeight - titleHeight - legendHeight);
      $(mainChart).css("top", newHeight - legendHeight);
    } else {
      $(mainChart).epoch({type: 'line'}).option("width", newWidth);
      $(mainChart).epoch({type: 'line'}).option("height", newHeight - titleHeight - legendHeight);
      $(mainChart).css("top", titleHeight);
    }

    // ChartUtil.setTimestampLabelSpacing($(mainChart));
  }

  static setMargins(widgetId, margins) {
    const $widget = $("#" + widgetId);
    const $chart = $widget.find("div.epoch")[0];
    $($chart).epoch({type: 'line'}).option("margins", margins);
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/chart-util.js